<template>
  <HomeTopHead />
  <HomeBanner />
  <LazyHomeCover />
  <LazyHomeFeatures />
  <LazyHomePromo />
  <LazyHomeProvides />
  <LazyHomeTestimonials />
  <TrustPilotTrustBox />
  <LazyHomeMobileApp v-if="false"/>
  <LazyHomeBlog />
  <LazySubscribe />
</template>

<script setup lang="ts">
import { eventTracker, AnalyticsEventKey } from '~/utils/analyticServices';

const { t } = useI18n();

useHead({
  title: t('meta.index.title'),
  meta: [
    { name: 'description', content: t('meta.index.description') },

    { property: 'og:title', content: t('meta.index.ogTitle') },
    { property: 'og:description', content: t('meta.index.ogDescription') },

    { property: 'twitter:title', content: t('meta.index.twitterTitle') },
    { property: 'twitter:description', content: t('meta.index.twitterTitle') },
    { property: 'twitter:card', content: 'summary_large_image' },
  ],
});

onMounted(() => {
  eventTracker(AnalyticsEventKey.LandingPageViewed);
  
  const isFirstLaunch = localStorage.getItem('isFirstLaunch');
  
  if (!isFirstLaunch) {
    eventTracker(AnalyticsEventKey.LaunchFirstTime, {
      platform: 'WebSite',
    });
    localStorage.setItem('isFirstLaunch', 'true');
  }
});
</script>